export default __webpack_public_path__ + "static/media/icon-taken-leave.2645a245.svg";